import React, { useEffect } from 'react'
import { NEXT_GEN_APP_URL } from 'utils/AllURLs'
import { useDeepLinkHandlerContext } from 'contexts/DeepLinkHandler'

/**
 * A component that listens for 'navigate' messages from the next-gen app and routes them
 */
export const NavigationMessageHandler = ({ children = null }) => {
  const { openDeepLink } = useDeepLinkHandlerContext()

  useEffect(() => {
    const messageListener = event => {
      // Only handle messages from the next-gen app
      if (event.origin !== NEXT_GEN_APP_URL) return
      // Handle navigation events
      if (event.data.type === 'navigate') {
        // Parse the payload and invoke the callback
        const { link } = event.data.payload
        openDeepLink(link)
      }
    }

    window.addEventListener('message', messageListener)

    return () => {
      window.removeEventListener('message', messageListener)
    }
  }, [openDeepLink])

  return <>{children}</>
}

export default NavigationMessageHandler
